const pkgStep = (name) => ({ packageId }) => ({ method: 'put', url: `/trip-wizard-${name}/${packageId}` });

export const STEP_ENDPOINTS = {
    overview: ({ tripId }) => (tripId
        ? { method: 'put', url: `/trip-wizard-destination/${tripId}` }
        : { method: 'post', url: '/trip-wizard-destination' }),          // flat body, no wrap
    packages: ({ packageId }) => (packageId
        ? { method: 'put', url: `/trip-wizard-packages/${packageId}` }
        : { method: 'post', url: '/trip-wizard-packages' }),
    pricing: pkgStep('pricing'),
    services: pkgStep('logistics'),
    departures: pkgStep('departures'),
    allocations: pkgStep('allocations'),
    itineraries: pkgStep('itineraries'),
    addons: pkgStep('addons'),
    faqs: pkgStep('faqs'),
};

export const STEP_KEYS = Object.keys(STEP_ENDPOINTS);